jQuery(document).ready(function( $ ){
	// START JQUERY
	logit = (typeof logit !== 'undefined')? logit : false;
	main_navbar = (typeof main_navbar !== 'undefined')? main_navbar :  'mainNavbar';
	main_nav = (typeof main_nav !== 'undefined')? main_nav :  'mainNav';


	scrollto_enable = (typeof scrollto_enable !== 'undefined')? scrollto_enable : true;
	scrollto_duration = (typeof scrollto_duration !== 'undefined')? scrollto_duration : 1000;
	scrollto_offset = (typeof scrollto_offset !== 'undefined')? scrollto_offset : 0;
	scrollto_autooffset = (typeof scrollto_autooffset !== 'undefined')? scrollto_autooffset : false;
	scrollto_autooffset_id = (typeof scrollto_autooffset_id !== 'undefined')? scrollto_autooffset_id : main_navbar;
	scrollto_scrollsnap_fix = (typeof scrollto_scrollsnap_fix !== 'undefined')? scrollto_scrollsnap_fix : false;
	scrollto_scrollsnap_class = (typeof scrollto_scrollsnap_class !== 'undefined')? scrollto_scrollsnap_class : 'snap-container';

	// start by adding parameters to html element or body or by enabling javascript variable scrollspy_enable
	// data-bs-target="#simple-list-example" data-bs-offset="0" data-bs-smooth-scroll="true"
	scrollspy_enable = (typeof scrollspy_enable !== 'undefined')? scrollspy_enable : false;
	scrollspy_target = (typeof scrollspy_target !== 'undefined')? scrollspy_target : main_nav;
	scrollspy_offset = (typeof scrollspy_offset !== 'undefined')? scrollspy_offset : 0;
	scrollspy_smooth = (typeof scrollspy_smooth !== 'undefined')? scrollspy_smooth : true;

	scrolldir_enable = (typeof scrolldir_enable !== 'undefined')? scrolldir_enable : false;
	scrolldir_target = (typeof scrolldir_target !== 'undefined')? scrolldir_target : 'body';
	scrolldir_up = (typeof scrolldir_up !== 'undefined')? scrolldir_up : 'scrolled-up';
	scrolldir_down = (typeof scrolldir_down !== 'undefined')? scrolldir_down : 'scrolled-down';

	scrollview_enable = (typeof scrollview_enable !== 'undefined')? scrollview_enable : false;
	scrollview_class = (typeof scrollview_class !== 'undefined')? scrollview_class : 'view-detect';
	scrollview_active = (typeof scrollview_active !== 'undefined')? scrollview_active : 'active';

	scrollpos_enable = (typeof scrollpos_enable !== 'undefined')? scrollpos_enable : false;
	scrollpos_target = (typeof scrollpos_target !== 'undefined')? scrollpos_target : 'body';
	scrollpos_offset = (typeof scrollpos_offset !== 'undefined')? scrollpos_offset : 0;
	scrollpos_top = (typeof scrollpos_top !== 'undefined')? scrollpos_top : 'scroll-top';
	scrollpos_middle = (typeof scrollpos_middle !== 'undefined')? scrollpos_middle : 'scroll-middle';
	scrollpos_end = (typeof scrollpos_end !== 'undefined')? scrollpos_end : 'scroll-end';



	// SCROLLSPY
	if(scrollspy_enable && $(scrollspy_target).length) {
		if(logit) console.log('[SCROLL SPY] Enabled' + scrollspy_target);
		if(logit == 2) console.log('[SCROLL SPY] target: ' + scrollspy_target + ', offset: ' + scrollspy_offset + ' smooth: ' + scrollspy_smooth);
		var scrollspy_selector = '#' + scrollspy_target;
		const scrollSpy = new bootstrap.ScrollSpy(document.body, {
			target: scrollspy_selector,
			offset: scrollspy_offset,
			smoothScroll: scrollspy_smooth
		});
	} else {
		if(logit == 3) console.log('[SCROLL SPY] Disabled');
	}

	// SCROLL TO
	if (scrollto_enable) {
		if(logit) console.log('[SCROLL TO] Enabled. Duration ' + scrollto_duration);

		function scrollTo(top=0) {
				if (scrollto_autooffset) {
					if(!scrollto_autooffset_id) scrollto_autooffset_id = scrollspy_target;
					var scrollto_autooffset_selector = '#' + scrollto_autooffset_id;
					scrollto_offset = $(scrollto_autooffset_selector).outerHeight();
					top = top - scrollto_offset;
					if(logit == 2) console.log('[SCROLL TO] Using auto offset: ' + scrollto_autooffset_id + ': ' + scrollto_offset);
				} else if (scrollto_offset) {
					top = top - scrollto_offset;
					if(logit == 2) console.log('[SCROLL TO] Using offset: ' + scrollto_offset);
				}
				if(logit == 2) console.log('[SCROLL TO] Scrolling to: ' + top);
				if(scrollto_scrollsnap_fix) {
					if(logit == 2) console.log('[SCROLL TO] Disabling scrollsnap while animating!');
					$('.'+ scrollto_scrollsnap_class).addClass(scrollto_scrollsnap_class + '-off');
					$('.'+ scrollto_scrollsnap_class).removeClass(scrollto_scrollsnap_class);
				}
				$('html,body').animate({
					scrollTop: top
				}, scrollto_duration, function() {
					if(scrollto_scrollsnap_fix) {
						$('.'+ scrollto_scrollsnap_class + '-off').addClass(scrollto_scrollsnap_class);
						$('.'+ scrollto_scrollsnap_class).removeClass(scrollto_scrollsnap_class + '-off');
					}
					if(logit == 2) console.log('[SCROLL TO] Finished!');
				});
				return true;
		}


		// to div by id
		$('a.scroll-link[href^="#"]:not([href="#"])').click(function( event ) {
				var target = $(this.hash);
				if(logit) console.log('[SCROLL TO] ' + target);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if(target.length && location.hostname == this.hostname) {
					if(this.pathname.replace(/^\//, '') == '' || location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')) {
						event.preventDefault();
						var top = target.offset().top;
						scrollTo(top);
						//if($('.navbar-collapse').length) $('.navbar-collapse').collapse('hide');
					} else { if(logit == 2) console.log('[SCROLL TO] ERROR: Failed on target filtering.'); }
				} else { if(logit == 2) console.log('[SCROLL TO] ERROR: Target not found or not in this hostname'); }
				return false;
		});

		// for 100%
		$('.scroll-100').click(function( event ) {
				event.preventDefault();
				var top = (window.innerHeight);
				if(logit) console.log('[SCROLL TO] 100% Window height!');
				scrollTo(top);
				return false;
		});

	  // To top
		$('.scroll-top').click(function( event ) {
					event.preventDefault();
					if(logit) console.log('[SCROLL TO] Top!');
					scrollTo(0);
					return false;
		});

	} else {
		if(logit == 3) console.log('[SCROLL TO] Disabled');
	}



	// SCROLL DIRECTION
	if(scrolldir_enable) {
		if(logit) console.log('[SCROLL DIR] Enabled. ' + scrolldir_target);
		var lastTop = $(window).scrollTop();
		var lastMovement = 0;
		var lastDirection = 0;
		$(window).scroll(function(event){
			var newTop = $(this).scrollTop();
			lastMovement += newTop - lastTop;
			maxScroll = $(document).height() - $(window).height();
			if(newTop < 0) newTop = 0;
			if(newTop > maxScroll) newTop = maxScroll;
			if (newTop > lastTop) {
				// scroll down
				if(logit == 2) console.log('[SCROLL DIR] Scrolled down');
				$(scrolldir_target).addClass(scrolldir_down);
				$(scrolldir_target).removeClass(scrolldir_up);
				if (lastDirection != 1) lastMovement = 0;
				lastDirection = 1;
			} else if (newTop < lastTop) {
				// scroll up
				if(logit == 2) console.log('[SCROLL DIR] Scrolled up');
				$(scrolldir_target).addClass(scrolldir_up);
				$(scrolldir_target).removeClass(scrolldir_down);
			  if (lastDirection != -1) lastMovement = 0;
				lastDirection = -1;
		 }
		 lastTop = newTop;
		});
	} else {
		if(logit == 3) console.log('[SCROLL DIR] Disabled');
	}


  if(scrollview_enable && scrollview_class) {
		if(logit) console.log('[SCROLL VIEWPORT] Enabled ' + scrollview_class);

		$.fn.isInViewport = function() {
			var elementTop = $(this).offset().top;
			var elementBottom = elementTop + $(this).outerHeight();
			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();
			var ofs = $(window).height()/2;
			var viewRes = elementBottom > (viewportTop-ofs) && elementTop < (viewportBottom-ofs);
			return viewRes;
		};

		$(window).on('resize scroll load', function() {
			$('.' + scrollview_class).each(function(i, obj) {
		    if($(this).isInViewport()) {
					$(this).addClass(scrollview_active);
				} else {
					$(this).removeClass(scrollview_active);
				}
			});
		});
	} else {
		if(logit == 3) console.log('[SCROLL VIEWPORT] Disabled');
	}



	if (scrollpos_enable) {
			if(logit) console.log('[SCROLL POS] Enabled ' + scrollpos_target);
			function checkNavTop(el,off) {
				var top = $(window).scrollTop();
				maxScroll = ($(document).height() - $(window).height());
				if(top < 0) top = 0;
				if(top > maxScroll) top = maxScroll;
				endScroll = maxScroll - off;
				if(top >= endScroll) {
					// END
					if(logit == 2) console.log('[SCROLL POS] End');
					$(el).removeClass(scrollpos_middle);
					$(el).removeClass(scrollpos_top);
					$(el).addClass(scrollpos_end);
				} else if (top > off) {
					// middle
					//if(logit == 2) console.log('[SCROLL POS] Middle');
					$(el).addClass(scrollpos_middle);
					$(el).removeClass(scrollpos_top);
					$(el).removeClass(scrollpos_end);
				} else {
					// top
					if(logit == 2) console.log('[SCROLL POS] Top');
					$(el).removeClass(scrollpos_middle);
					$(el).removeClass(scrollpos_end);
					$(el).addClass(scrollpos_top);
				}
			}
			$(window).on('resize scroll load', function(){
				checkNavTop(scrollpos_target,scrollpos_offset);
			});
	} else {
		if(logit == 3) console.log('[SCROLL POS] Disabled');
	}






	// END JQUERY
});
